module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Top', {
    attrs: {
      "title": "Вебинары",
      "subtitle": "Видеоматериалы, вебинары."
    }
  }, [(_vm.isLoading) ? _c('LoadingSpinner', {
    attrs: {
      "size": 100
    }
  }) : [(_vm.isError) ? _c('Infotext', {
    attrs: {
      "text": "Ошибка"
    }
  }) : [(_vm.data.length) ? [(!_vm.isSferumModule) ? _c('Info', {
    attrs: {
      "items": _vm.data,
      "show-addition": false
    }
  }) : _c('InfoSferum', {
    attrs: {
      "items": _vm.data
    }
  })] : _c('Warning', {
    attrs: {
      "isHeader": false
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.errorText ? _vm.errorText : 'На данный момент вебинары не проводятся.'))])])]], (_vm.isSferumModule && _vm.data.length) ? _c('Paginator', {
    staticClass: "webinars_paginator",
    attrs: {
      "count": _vm.pagesCount,
      "current": _vm.paginatorData.page,
      "max": 6
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-356d3eef","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/webinars/Webinars.vue
// module id = 66a38dfcf55d8d598158
// module chunks = 14